import Failure from '../../../core/Failure';
import HttpClient from '../../../core/HttpClient';
import { Authentication } from '@leedpulse-monorepo/classes';

async function getFileHeaders(
  payload: FileHeadersPayload,
  auth: Authentication
): Promise<any> {
  try {
    const formData = new FormData();
    formData.append('file', payload.file);

    return await HttpClient.post('/contacts/file/headers', formData, auth.token, true);
  } catch (e) {
    console.log('error: ', e);
    throw new GetFileHeadersFailure();
  }
}

export class FileHeadersPayload {

  file: File;

  constructor(
    file: File
  ) {
    this.file = file;
  }
}

export class GetFileHeadersFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}

export default getFileHeaders;
